import { Component } from '@angular/core';

@Component({
  selector: 'hadsup-shimmer-box',
  templateUrl: './shimmer-box.component.html',
  styleUrl: './shimmer-box.component.scss',
  standalone: false,
})
export class ShimmerBoxComponent {

}
